<app-dialog [dialogWithInput]="dialog" [manualCloseManagement]="true" (closeEvent)="close()">
    <app-card>
        <div class="row">
            <app-form-field [size]="12" [sizeLg]="12" [sizeXl]="12" [label]="dialog.input.label">
                <app-input-text #inputTextComponent
                                (keyPressedEvent)="keyPressed($event)"
                                [parentFormGroup]="formGroup" parentFormControlName="comment"></app-input-text>
            </app-form-field>
        </div>
    </app-card>
</app-dialog>
